import Notice from './notice';

export default {
  init: function (selector) {
    const notices = document.querySelectorAll(selector);

    if (notices && notices.length) {
      [...notices].map(item => {
        const notice = new Notice(item);
        notice.init();
      });
    }
  }
};
